import FileDownload from 'react-file-download';
import qs from 'qs';
import api from '../irelandApi';

const pipEposDataUrl = '/api/admin/pip_epos_data';

export const downloadPipEposDataErrorsReport = (startDate, endDate) => () => {
  const query = {
    start_date: startDate,
    end_date: endDate,
  };

  return api.get(`${pipEposDataUrl}/download_errors_report?${qs.stringify({ query }, { encodeValuesOnly: true })}`)
    .then((response) => {
      const fileName = 'pip-epos-errors-report.csv';

      FileDownload(response.data, fileName);
    });
};

export const downloadPipEposDataMissingReport = (startDate, endDate) => () => {
  const query = {
    start_date: startDate,
    end_date: endDate,
  };

  return api.get(`${pipEposDataUrl}/download_missing_report?${qs.stringify({ query }, { encodeValuesOnly: true })}`)
    .then((response) => {
      const fileName = 'pip-epos-missing-weeks-report.csv';

      FileDownload(response.data, fileName);
    });
};
